export default {
  SKUS: "/generic/module",
  POPUP: "/generic/module/view", // 获取弹窗内容
  GETSELECTARRAY: "/generic/module/selection",
  Add: "/generic/module/adding",
  UPDATE: "/generic/module/updating", // neibu 更新/删除
  SKUSTAB: "/generic/module/tab",
  IMPORT: "/generic/module/import", // 导入;
  SEARCHSORT: "/generic/module/sort", // get获取用户配置的sort post保存用户配置的sort
  QUERYFILTER: "/generic/module/sql", // 获取query filter p配置
  DELETETEMPLATE: "/generic/deletion/template", // 删除一个AdvanceSearch的模板
  GETCODEMASTINFO: "/generic/module/getCodeMasterSetting", //获得CodeMaster的克隆配置
  CLONECODEMASTER: "/generic/module/cloneCodeMaster", //克隆Code Master
  OUTSTANDINGDETAIL: "/so/outStandingDetail", // 获取"[Manual]"detail
  IMPORTEXCEL: "/generic/excel", // 导入excel
  SOBANABCE: "/so/balance",
  SOPICK: "/so/pick",
  SOFINDALLOCATION: "/so/findAllocation",
  SODETAILALLLOCATION: "/so/detail/allocation",
  SOHEADERALLOCAION: "/so/header/allocation",
  WAREHOUSEDROP: "/generic/module/dropdown/warehouse",
  SUBMITGENERATIONLOCATION: "/generic/extender/generation/location",
  DROPTABNAME: "/generic/dropdown/tabName",
  USERPROJECTCODE: "/user/projectCode",
  ORGANIAZTION: "/so/rule/organization", // orgCode下拉数据
  RULEPROJECT: "/so/rule/project", // projectCode下拉数据
  QUERYRULE: "/so/rule", // rule 列表
  SAVESORULEHEADER: "/so/ruleHeader", // 保存ruleHeader
  SORULEDETAILID: "/so/ruleDetail/id", // 查找rule详情
  SORULETABLENAME: "/so/rule/tableName",
  SORULEFIELDNAME: "/so/rule/fieldName", // 根据tableName，查找fieldName下拉数据
  SAVESORULEDETAIL: "/so/ruleDetail", // 保存ruleDetail
  RULEDETAILSEQ: "/so/ruleDetail/seq",
  SODELETERULEDETAIL: "/so/delete/ruleDetail", // 根据规则Uid删除模板
  SODELETERULEHEADER: "/so/delete/ruleHeader", //根据规则Uid删除模板
  SCANTABLE: "/pack/scan/table",
  GETALLUPC: "/pack/scan/getupc",
  CHECKSOSTATUS: "/pack/scan/checkSOStatus",
  TRACKINGNO: "/so/trackingNo",
  SAVECARTON: "/pack/scan/saveCarton", // 保存carton
  PACKSCANSAO: "/pack/scan", //
  GETSOWAVE:"/so/wave",
  SAVESOWAVE:"/so/wave/save",
  SEARCHSCANCARTON: "/pack/scan/carton",
  SCANCLOSE: "/pack/scan/close", // close carton
  CARTONINFO:"/scanPack/cartonInfo",
  APPENDSCAN: "/pack/scan/append", // open carton
  REMOVESCANPACK: "/pack/scan/remove", // 删除rremove carton
  SCANCANCELPACK: "/pack/scan/cancel",
  AFTERSHIPCREATELABEL: "/pack/scan/afterShip/createLabel", // afterShip create a label
  AFTERSHIPCANCELLABEL: "/pack/scan/afterShip/cancelLabel", // afterShip cancel a label
  AFTERSHIPCREATEMANIFEST: "/pack/scan/afterShip/createManifest", // afterShip Create manifest
  SCANINTABLE: "/scan/table", // SCANIN
  SCANLOCATION: "/scan/location/table", // NEW location table
  SACNINSKUSAOMA: "/scan/sku", // sacanin 扫货
  SACNINSKUCHECK: "/scan/skuCheck",
  SCANINLISTSKU: "/scanIn/listSku", // scan in缓存扫描批量提交
  ScanDeleteContailerId: "/scan/deleteContainerId", // sacanin 扫描
  CountScanQtyByContainerId:"/scan/countScanQtyByContainerId",
  SCANINCANCEL: "/scan/cancel", // SCANIN 回退
  CONVERTTORECEIVE:"/scanin/convertToRec",//"/scan/convertToReceive",//Scan In 页面convertToReceive
  FARFETCHRETURNCONFIRMATION:"/scanin/farfetchReturnConfirmation",
  LOADINGGETLOADBYUID: "/loading/getLoadByUid", // SCAN LOADING getLoadByUid
  LOADINGSHIPMENTBYLOADUID: "/loading/getLoadingShipmentByLoadUid",
  SAVELOADHEADERANDSHIPMENT:"/loading/saveLoadHeaderAndShipment",
  LOADINGSCAN: "/loading/scan", // SCAN LOADING
  LOADINGTABLE: "/loading/table", // loading table
  DELETELOADINGSSCC:"/delete/loading/sscc",//delete loading sscc
  EXTENDERDEALL: "/packHeader/extender/de-all" , // scanpack confirm
  CANCELCHECKCOMPLETE : "/so/cancelCheckComplete",// scanpack cancel check complete
  CHECKPARTIALPACK : "/so/checkPartialPack",
  CANCELPICKFORCHECKCOMPLETE: "/so/cancelPickForCheckComplete",
  USERDROPDOWNWHS: "/user/dropDown/whs", // Warehouse下拉数据
  INVENTORYADJEADER: "/inventory/invAdjHeader", // adjust header save
  INVENTORYLOCATION: "/inventory/location", // location search
  INVENTORYSKU: "/inventory/sku",
  INVENLOGICALWHS: "/inventory/logicalWhs",
  INVDETAILPUB: "/inventory/invDetail", // OK保存invMoveDetail
  INVENTORYREASONCODE: "/inventory/reasonCode", // 下拉reasonCode 的值
  UPDATEINVADJDETAIL: "/inventory/update/invAdjDetail", // ADJUST table 保存
  DELINVADJDETAIL: "/inventory/del/invAdjDetail", // ADJUST 删除
  CANCELINVADJHEADER: "/inventory/cancel/invAdjHeader", // cancel ajust
  INVADJHEADERCONFIRM: "/inventory/invAdjHeader/confirm", // ajust header confirm
  INVADJREQUESTAPPROVAL:"/inventory/invAdj/requestApproval",
  INVADJCANCELREQUEST:"/inventory/invAdj/cancelRequest",
  MOVELOGICSELECT: "/inventory/moveLogic", // logic select data
  MOVEREASONSELECT: "/inventory/moveReason", // Reason select data
  TRANSFERREASONSELECT: "/inventory/transferReason", // Reason select data
  INVMOVEHEADER: "/inventory/invMoveHeader",
  UPDATEINVMOVEDETAIL: "/inventory/invMoveDetail",
  UPDATEINVTRANSFERDETAIL: "/inventory/invTransferDetail",
  DELINVMOVEDETAIL: "/inventory/del/invMoveDetail", // MOVE table shanchu
  INVENTORYMOVECANCEL: "/inventory/cancel/invMoveHeader", // MOVE cancel
  SPLITTABLE: "/split/table", // SPLIT table
  SPLITSAVE: "/split",
  PRINTPREVIEW: "/report/generic/print/preview", // scanpacK 打印pdf
  PRINTPREVIEWBYUDR: "/report/generic/print/printPreviewByUDR",
  PRINTTODSB2BPICKINGLIST:"/print/todsReportPrintLimit",
  AUPRINTCAINIAOJDLABEL:"/outbound/autoPrintCainiaoJdLabel",
  GENERATELABEL: "/pack/scan/generateLabel", // scanpacK GenerateLabel
  CANCELLABEL: "/pack/scan/cancelLabel", // scanpacK CancelLabel
  GENERATEMAINFEST: "/pack/scan/generateMainfest", // scanpacK generateMainfest
  PACKCARTONTYPELIST: "/pack/carton/type/list", // CARTON  type 下拉数据
  PACKCARTONTYPE: "/pack/carton/type", //carton detail
  GETCOMPONENT: "/pack/scan/component",
  SOEXTENDERCONFORM: "/outbound/extender/confirm",
  GETSCANPACKORDERINFO: "/pack/scan/orderInfo",
  SCANINIDGET: "/scanin/id",
  MOVECONFIRMINVENTORY: "/inventory/invMoveHeader/confirm",
  PACKSCANDETAIL: "/pack/scan/detail", // scanpack detail
  IMPORTSCANNINGFILE: "/pack/importScanningFile",
  INVTRANSFERHEADER: "/inventory/invTransferHeader",
  INVENTORYFIELDNAME: "/inventory/fieldName", // findInvFieldName
  INVTRANSFERDETAIL: "/inventory/invTransferDetail",
  INVTRANSFERHEADERCANCEL: "/inventory/cancel/invTransferHeader",
  UPDATTEINVTRANSFERDETAIL: "/inventory/update/invTransferDetail",
  DELINVTRANSFERDETAIL: "/inventory/del/invTransferDetail",
  TRANSFERHEADERCONFIRM: "/inventory/invTransferHeader/confirm", // "/inventory/transferHeader/confirm",
  GENERICUOM: "/generic/uom", // 获取package 下拉数据转sku
  INVENTORYMOVESPLIT: "/inventory/move/spilt",
  IMPORTMODULEEXPORT: "/generic/module/export",
  EXTENDERINVMOVE: "/inventory/extender/invMove",
  GEBERICMODULESTATUS: "/generic/module/status",
  EDITINVRNTORYINVSAVE: "/inventory/inv/save",
  EDITADJUSTDETAILSAVE: "/inventory/invAdjDetail",
  GENERICUOMWGT: "/generic/uom/wgt",
  GENERICPRINTNODEALLBTN: "/generic/printNode/allBtn/config",
  GENERICPRINTNODEALLBTNFORLOAD: "/generic/customized/config",
  GENERICPRINTNODEBATCH: "/generic/printNode/batch",
  INVTRANSFERHEADERTRANSIT: "/inventory/invTransferHeader/transit",
  GETINVTRANSFERHEADER: "/inventory/invTransferHeader",
  INVENTORYINVTRANSFER: "/inventory/invTransfer",
  INVENTORYINVADJUETMENT: "/inventory/invAdjuetMent",
  INVENTORYINVADJUETMENTHEADER: "/inventory/invAdjHeader",
  INVENTORYINVMOVE: "/inventory/invMove",
  INVENTORYINVSAVE: "/inventory/inv/save",
  INVENTORYINVSAVEUDF: "/inventory/inv/saveUdf",
  INVENTORYINVMOVEHEADER: "/inventory/invMoveHeader",
  INVENTORYINVMOVEINFO: "/inventory/invMoveInfo",
  INVENTORYINVTRANSFERINFO: "/inventory/invTransferInfo",
  INVENTORYCYCLECOUNTASSIGNEDUSERLIST: "/inventory/cycleCount/getProjectAssignedUserList",
  INVENTORYCYCLECOUNTUPDATEASSIGNEDUSER: "/inventory/cycleCount/updateCycleCountTicketAssignedUser",
  INVENTORYCYCLEGETLEGALCREATELOCATION: "/inventory/cycleCount/getLegalCreateLocation",
  INVENTORYCYCLECREATETICKET: "/inventory/cycleCount/CreateTicket",
  USERDROPDOWNWHSPRINT: "/user/dropDown/whs",
  INVENTORYINVTRANSFERUDF: "/inventory/invTransferUdf",
  EXTENDERUNASSIGN: "/wave/extender/unassign",
  EXTENDERASSGIN: "/wave/extender/assign",
  GENERICUGCMENU: "/generic/ugc/menu",
  GEBERICUGCUSER: "/generic/ugc/user",
  WAVECRITERIATRIGGER: "/extender/trigger",
  DELETEJOBSCHEDULE: "/schedule/deleteJob",
  ADDJOBSCHEDULE: "/schedule/addJob",
  GEERICUDRPUBLISH: "/generic/udr/template/publish",
  WAVECRITEREXTENDERTRIGGER: "/waveCriteria/extender/trigger",
  LOGINAPI: "/login",
  AUTHORIZATIONCODE: "/user/AuthorizationCode",
  USERCHANGEPWD: "/user/changePwd",
  INBOUNDBATCHRECEIVE: "/inbound/batch/receive",
  RECBATCHEDITOR: "/rec/batch/editor",
  RECBATCHEDIORSTATUS: "/rec/batch/editor/status",
  SPLITRECHEADER:"/rec/split",

  SOSKU: "/so/sku",
  SOINVSKU: "/so/inv/sku",
  SOCREATESODETAIL: "/so/create/soDetail",
  SOEDITORSODETAIL: "/so/editor/soDetail",
  SOSAVESODETAIL: "/so/save/soDetail",
  SOFINDQUICKEDIT: "/so/find/quickEdit",
  SOSAVEQUICKEDIT: "/so/save/quickEdit",
  CHECKEXPORTSOORDERSTATUS : "/so/checkExportSoOrderStatus",
  CHECKEXPORTSOORDERSTATUSNEW : "/so/checkExportSoOrderStatusNew",
  EXPORTGARMANIDELIVERYNOTE: "/so/exportGArmaniDeliveryNote",
  EXPORTSHIPMENTCONFIRMATION: "/so/exportShipmentConfirmation",
  EXPORTPACKAGEDATA: "/so/exportPackageData",
  VERIFYORDERANDGROUPBYSHIPMENTNO: "/so/verifyOrderAndGroupByShipmentNo",
  RELEASEREPORTBYEXCEL: "/so/releaseReportByExcel",
  CHECKEXPORTRELEASEORDERSTATUS: "/so/checkExportReleaseOrderStatus",
  ASNEXTENDERCONVERTRECEIVE: "/asn/extender/convertToReceive",
  SCANDIRECLYTABLE: "/scan/directly/table",
  INVENTORYEXPORTTRANSFEREXCEL: "/generic/export/transfer/excel",
  ASNLIST:"/asn/list",
  ASNDETAILLIST:"/asnDetail/list",
  SKULIST:"/sku/list",
  SEARCHSKU:"/search/sku",
  ASNHEADER:"/asn/getHeader",
  ASNDETAIL:"/asn/getDetail",
  ASNSAVEHEADER:"/asn/saveHeader",
  ASNSAVEDETAIL:"/asn/saveDetail",
  DELETELIST:"/asn/deletelist",
  DELETEDETAILLIST:"/asn/deleteDetaillist",
  GETFILENAME:"/asn/getFileName",
  DELETEFILE:"/asn/deleteFile",
  DOWNLOADFILE:"/asn/downloadFile",
  DOWNLOADZIP:"/asn/downloadZip",
  EXPORTASNORDERDATA: "/asn/exportAsnOrder",
  CHECKEXPORTASNORDERSTATUS: "/asn/checkExportAsnOrderStatus",
  EXPORTDISCREPANCYREPORT: "/asn/exportDiscrepancyReport",
  EXPORT_PRODUCT_LABEL: "/asn/exportProductLabels",
  EXPORT_GOOD_RECEIPTS: "/asn/exportGoodReceipts",
  ASN_CHANGE_WH_PROJECT: "/asn/changeWhProject",
  ASN_VALIDATE_CHANGE_WH_PROJECT: "/asn/validateChangeWhProject",
  SO_CHANGE_WH_PROJECT: "/so/changeWhProject",
  SO_VALIDATE_CHANGE_WH_PROJECT: "/so/validateChangeWhProject",
  JOBLIST:"/job/list",
  GETWAVEID:"/getWaveId",
  JOBDETAIL:"/job/getDetail",
  JOBSAVEDETAIL:"/job/saveDetail",
  DELETEJOBDETAIL:"/job/deleteDetail",
  JOBPARAMLIST:"/job/paramList",
  JOBSAVEPARAM:"/job/saveParam",
  TIMERLIST:"/timer/list",
  GETTIMER:"/timer/getTimer",
  RUN:"/manual/schedule",
  GETTRANSACTIONLOG:"/inventory/transactionLog",
  EXPORTINVTRANLOG:"/inventory/exportInvTranLog",
  TIMERSAVE:"/timer/saveTimer",
  DELETETIMER:"/timer/deleteTimer",
  SETTIMERSTATUS:"/timer/setTimerStatus",
  INVENTORYIMPORTTRANSFEREXCEL: "/inventory/import/transfer/excel",
  SOIMPORTSTOREARRIVAL:"/so/importStoreArrival",
  SCANPACK: "/scanPack",
  CFSSCANPACKSEARCHORDERNO: "/cfs/scanPack/searchOrderNo",
  CFSSCANPARCELNO: "/cfs/scanPack/scanParcelNo",
  CFSPRINTPARCELNO: "/report/generic/scanPack/printParcelNo",
  CFSLOADPARCELNO: "/cfs/scanLoad/loadParcelNo",
  CFSCREATELOADING: "/cfs/scanLoad/createLoading",
  CREATELOADINGSPECIAL: "/cfs/scanLoad/createLoadingSpecial",
  CFSCONFIRMLOADING: "/cfs/scanLoad/confirmLoading",
  CFSSAVELOADING: "/cfs/scanLoad/saveLoading",
  CFSCOPYLOADING: "/cfs/scanLoad/copyLoading",
  CFSSCANINSCANBARCODE: "/cfs/scanIn/scanBarcode",
  CFSSCANINDELETEBARCODE: "/cfs/scanIn/deleteBarcode",
  CFSSCANLOADSEARCHSCANLOAD: "/cfs/scanLoad/searchScanLoad",
  CFSGETALLCARTONTYPE: "/cfs/scanLoad/getAllCartonType",
  CONSOLIDATIONSCANBARCODE:"/android/consolidation/scanBarcode",
  CONSOLIDATIONSAVEDATA:"/android/consolidation/saveData",
  CONSOLIDATIONGETUOM:"/android/consolidation/getUom",
  CONFIRMMANUALALLOCATION: "/backend/confirmManualAllocation",
  GETPROJECTCODES: "/so/getProjectCode",
  EXPORTDELIVERYORDERSUMMARY: "/so/exportDeliveryOrderSummary",
  GETORDERBYINVENTORYDATA:"/getOrderByInventoryData",
  GETDELIVERYORDERSUMMARYLIST: "/so/getDeliveryOrderSummaryList",
  GETSTDBALANCEREPORTLIST: "/inventory/getSTDBalanceList",
  PREVIEWIMGFILE:"/inventory/previewImgFile",
  GETRESPLANHEADERLIST: "/getResPlanHeaderList",
  GETRESPLANDETAILLIST: "/getResPlanDetailList",
  SAVERESPLANHEADER:"/saveResPlanHeader",
  SAVERESPLANDETAIL:"/saveResPlanDetail",
  CREATERESPLANDATA:"/createResPlanData",
  EXPORTSTDBALANCELIST: "/inventory/exportSTDBalanceList",
  GETSCANPACKUDFDISNAME:"/so/scanpack/disName",
  GETSCANPACKALERTMSGFLAG:"/so/scanpack/alertMsgFlag",
  OPERATORList: "/inventory/operatorInfo",
  LOCATIONINFO: "/inventory/locationInfo",
  LOTIDINFOLIST: "/inventory/lotIdInfo",
  PROJECTUSERDEFINEDFILEDINFO: "/inventory/projectUserDefinedFiledInfo",
  FINDDATABYCODEGROUP: "/inventory/findDataByCodeGroup",
  GETMAINTENANCELIST:"/so/getMaintenanceList",
  ADDMAINTENANCELIST:"/so/addMaintenanceList",
  DELETEMAINTENANCELIST:"/so/deleteMaintenanceList",
  SCANPACKGETSCANPACKSTAUS:"/scanPack/getScanPackStaus",
  SCANPACKCLOSEORDER:"/scanPack/closeOrder",
  SCANPACKSENDEDI: "/packHeader/extender/scanPackSendEdi" , // scanpack SendEDI
  AUTOPRINTHTTPFILE: "/config/http/autoPrintHttpFile", // 自动打印网络地址文件
  PRINTVIEWHTTPFILE:"/config/printViewPrice",
  AUTOPRINTCFSLOADING: "/cfs/config/autoPrintCfsLoading",
  AUTOPRINTPRICE: "/config/autoPrintPrice",
  QUERYDETAILPRINTPRICE:"/config/queryDetailPrintPrice",
  PRINTPREVIEWREPORT: "/cfs/report/previewReport", // 打印预览报表
  INVENTORYCYCLECOUNTMASTERCHECKCREATECOUNTORDER:"/cycleCountMaster/checkCreateCountOrder",
  INVENTORYCYCLECOUNTMASTERCREATECOUNTORDER:"/inventory/cycleCountMaster/createCountOrder",
  INVENTORYCYCLECOUNTMASTERQUERYLOCATIONANDSKU:"/inventory/cycleCountMaster/queryLocationAndSku",
  INVENTORYCYCLECOUNTCREATETICKETBYNEWORRECOUNT:"/inventory/cycleCount/createTicketByNewOrReCount",
  INVENTORYCYCLECOUNTQUERYTICKETINFO:"/inventory/cycleCount/queryTicketInfo",
  GETPICKLOCATIONLISTBYSO:"/so/getPickLocationListBySo",
  SETUSERTOPICKLOCATION:"/so/setUserToPickLocation",

  CREATE_DHL_SHIPMENT_ID:"/so/createDhlShipmentId",
  ADD_ORDER_TO_SHIPMENT_ID:"/so/addOrderToShipmentId",
  FIND_SHIPMENT_REFERENCE:"/so/findShipmentReference",

  SCANTOPRINT:"/report/generic/scanToPrint",
  SCANTOPRINTPDF:"/report/generic/scanToPrint/pdf",
  CODEMAST: "/user/codeMast",
  SCANPACKCHECKSCSSKU: "/scanPack/checkCusSku",
  SCANPACKCHECKEPCBYORDERTYPE: "/scanPack/checkEpcByOrderType",
  SCANINCHECKSCSSKU: "/scanIn/checkCusSku",
  GENERICGETSTATUSBUTTONBYPAGE: "/generic/getStatusButtonByPage",
  ASNIMPORTSCANNINGFILE: "/asn/importScanningFile",
  INPORTKATESPADEEXCEL: "/backend/import/kateSpadeDeliverySlip",
  LOADINGSEARCHWAVECARTON:"/loading/searchWaveCarton",
  LOADINGSCANBYWAVE: "/loading/scanByWave",
  LOADINGIMPORTSSCC: "/loading/importSscc",
  SCANINCHECKRFIDISFROMOUTBOUND: "/scanIn/checkRfidIsFromOutbound",
  GETHUDFANDEDISENDTIME:"/so/loading/getHudfAndEdiSendTime",
  IMPORTSCANCHECK:"/scan/pack/importScanCheck",
  GENERICGETQRCODESELECT: "/generic/getQrCodeSelect",
  GROUPWAVE:"/generic/so/groupWave",
  GETGROUPWAVEDISNAME:"/so/getGroupWaveDisName",

  SPLITSCANQUERY: "/splitScan/query",
  SPLITSCANSCAN: "/splitScan/scan",
  SPLITSCANREMOVE: "/splitScan/remove",
  SPLITSCANEXPORTEXCEL: "/splitScan/exportExcel",


  SEARCHSOORDERBYINFO: "/pick_to_zero/table",
  SCANPICKTOZEROSKU: "/scan/pick_to_zero/sku",
  SEARCHPICKTOZEROCARTON: "/pick_to_zero/carton",
  SCANPICKTOZEROPACKDETAIL: "/pick_to_zero/packDetail",
  PICKTOZEROCARTONSAVE: "/pick_to_zero/carton/save",
  PICKTOZEROCARTONCLOSE: "/pick_to_zero/carton/close",
  PICKTOZEROCARTONAPPEND: "/pick_to_zero/carton/append",
  PICKTOZEROCARTONREMOVE: "/pick_to_zero/carton/remove",

  PICKTOZEROCANCELPACKBYPO: "/pick_to_zero/cancelPack/po",
  PICKTOZEROCANCELPACKBYSO: "/pick_to_zero/cancelPack/so",
  PICKTOZEROCANCELPACKBYLINE: "/pick_to_zero/cancelPack/line",

  PICKTOZEROBATCHCLOSECARTON: "/pick_to_zero/batchClose/carton",
  PICKTOZEROCHECKCOMPLETE: "/pick_to_zero/checkComplete",
  PICKTOZEROCANCELCHECKCOMPLETE: "/pick_to_zero/cancelCheckComplete",
  PICKTOZEROCLOSE: "/pick_to_zero/close",

  INVENTORYDPWDASHBOARDINFO: "/inventory/dpwDashboardInfo",

  GETEDIMASTLIST:"/ediMast/getEdiMastList",
  GETEDIMASTDTLLIST:"/ediMast/getEdiMastDtlList",
  SAVEEDIMAST:"/ediMast/saveEdiMast",
  SCANPACKNEWBYORDER: "/scanPackNew/searchByOrder",
  SCANPACKNEWGETITEMSINTHISCARTON: "/scanPackNew/getItemsInThisCarton",
  SCANPACKNEWSEARCHSUMMARY: "/scanPackNew/searchSummary",
  SCANPACKNEWSEARCHCARTON: "/scanPackNew/searchCarton",
  SCANPACKNEWGETINSTRUCTION: "/scanPackNew/getInstruction",
  SCANPACKNEWGETMATERIALS: "/scanPackNew/getMaterials",
  SCANPACKNEWSAVEMATERIALS: "/scanPackNew/saveMaterials",
  SCANPACKNEWCHECKMATERIALS: "/scanPackNew/checkMaterials",
  SCANPACKNEWGETMATERIALLIST: "/scanPackNew/getMaterialList",
  SCANPACKNEWEXPORTSUMMARY: "/scanPackNew/exportSummary",
  SAVEEDIMASTDTL:"/ediMast/saveEdiMastDtl",
  UPLOADASNDETAIL: "/uploadAsnDetail",
  SCANPACKNEWGETAUTOPRINTLABEL: "/scanPackNew/getAutoPrintLabel",
  CREATECYCLECOUNTBYIMPORTFILE:"/inventory/cycleCountMaster/createCycleCountByImportFile",
  PRINTSFIBSLABELPDF:"/scanpack/printSfIbsLabelPdf",
  BATCHINVLOCATION:"/inventory/cycleCount/invLocation",
  GETSELECTOFFLINECOUNTRESULTLIST:"/getSelectOfflineCountResultList",
  DELETESELECTOFFLINECOUNTRESULT:"/deleteSelectOfflineCountResult",
  IMPORTSELECTOFFLINECOUNTRESULT:"/importSelectOfflineCountResult",
  AUTHINITIATE:"/user/auth/initiate",
  AUTHCHECKUSERDOMAIN:"/user/auth/checkUserDomain",
  CHECKASNRECQTY:"/asn/checkAsnRecQty",
}
